import { endPoint } from "./base.config";

export const service = {
  ehf: `${endPoint}company/services/ehf`,
  infor_ehf: `${endPoint}elma/participants/`,
  deleteEhf: `${endPoint}company/services/ehf/delete`,
  alert: `${endPoint}company/services/alert`,
  getOwner: `${endPoint}company/getOwner`,
  addCompanyUsers: `${endPoint}company/addCompanyUsers`,
  getCompanyDivisionByOrg: `${endPoint}company/get-company-division-by-org`,
  addCompanyDivisionByOrg: `${endPoint}company/add-company-division-by-org`,
  updateCompanyDivisionByOrg: `${endPoint}company/update-company-division-by-org`,
  deleteCompanyDivision: `${endPoint}company/delete-company-division`,
  getEHFAccessPointUrl: `${endPoint}company/services/ehf/get-access-point-url`,
}